export const AUTH_STRINGS = {
	common: {
		errorMessage: {
			offline:
				"You appear to be offline. Please check your internet connection, then try again.",
			serverUnreachable:
				"We couldn't reach the authentication server. Please try again in a moment, or contact support@studio3t.com if the problem persists.",
			generic:
				"Something went wrong. Please try again, or contact support@studio3t.com if the problem persists.",
		},
	},
	signIn: {
		challengeName: {
			newPassword: "NEW_PASSWORD_REQUIRED",
		},
		cognitoError: {
			errorCode: {
				notAuthorized: "NotAuthorizedException",
			},
			errorMessage: {
				incorrectUsernameOrPassword: "Incorrect username or password.",
				incorrectCredentials:
					"Your email address or password are incorrect. Please try again, or recover your password.",
			},
		},
		emptyCredentials: {
			errorMessage: {
				emptyUsernameOrPassword:
					"Some of the required fields are missing or incorrect. Please review your data, then try again.",
			},
		},
	},
	signUp: {
		cognitoError: {
			unAuthorizedUser: {
				errorMessage:
					"We apologize for the inconvenience, but there seems to be an error with the sign-up process. Please cancel your sign-up and attempt to register again. If the issue persists, please contact support@studio3t.com for further assistance.",
			},
			errorCode: {
				invalidParameter: "InvalidParameterException",
				userExists: "UsernameExistsException",
			},
			errorMessage: {
				invalidPhone: "Invalid phone number format.",
				invalidEmail: "Username should be an email.",
			},
		},
	},
};

export const QUERY_PARAMS_KEYS = {
	authCode: "authorization_code",
	challenge: "code_challenge",
	challengeMethod: "code_challenge_method",
	clientID: "client_id",
	forceAuth: "forceAuth",
	logoutURI: "logout_uri",
	originURI: "origin_uri",
	redirectURI: "redirect_uri",
	responseType: "response_type",
	state: "state",
};

export const STORAGE_KEYS = {
	authCode: "authorization_code",
	clientID: "client-id",
	debug: "debug",
	originURI: "origin_uri",
	redirectInfo: "redirectInfo",
	redirectURI: "client-redirect-uri",
	state: "client-state",
};
